/**
 * Render generated description HTML as a preview WITHOUT innerHTML: the markup
 * is parsed inert (DOMParser does not run scripts), then rebuilt as React
 * nodes from a small tag whitelist with every attribute dropped. Anything
 * else is flattened to its text. Model output is untrusted.
 */
import React from 'react';

const ALLOWED = new Set(['p', 'ul', 'ol', 'li', 'strong', 'b', 'em', 'i', 'br', 'h3', 'h4', 'h5']);

const CLS: Record<string, string> = {
  p: 'mb-2 last:mb-0', ul: 'list-disc pl-5 mb-2', ol: 'list-decimal pl-5 mb-2', h3: 'font-semibold mb-1', h4: 'font-semibold mb-1', h5: 'font-semibold mb-1',
};

function toReact(node: Node, key: string): React.ReactNode {
  if (node.nodeType === 3) return node.textContent;
  if (node.nodeType !== 1) return null;
  const el = node as Element;
  const tag = el.tagName.toLowerCase();
  const children = Array.from(el.childNodes).map((c, i) => toReact(c, `${key}.${i}`));
  if (tag === 'script' || tag === 'style') return null;
  if (!ALLOWED.has(tag)) return <React.Fragment key={key}>{children}</React.Fragment>;
  if (tag === 'br') return <br key={key} />;
  return React.createElement(tag, { key, className: CLS[tag] }, ...children);
}

export const SafeHtmlPreview: React.FC<{ html: string }> = ({ html }) => {
  if (typeof DOMParser === 'undefined') return <>{html}</>;
  const doc = new DOMParser().parseFromString(`<body>${html}</body>`, 'text/html');
  return <>{Array.from(doc.body.childNodes).map((n, i) => toReact(n, String(i)))}</>;
};
